export default {
  // 左侧菜单项
  menuItems: {
    details: {
      text: "展开详情",
      tooltip: "可查看节点或交易边的详情内容",
    },
    model: {
      text: "AI模型",
    },
    canvasfilter: {
      text: "画布筛选",
    },
    history: {
      text: "历史记录",
    },
    suggestion: {
      text: "调证建议",
    },
  },
};
